import React from "react";
import useUser from "../../hooks/useUser";
import { useTranslation } from "react-i18next";
import ToggleDrawer from "../../contexts/ToggleDrawer";
import CustomDialog from "./CustomDrawer";
import ClinicPickerDialog from "../dialogs/ClinicPickerDialog";
export default function NoClinicWrapper({ children, show = true }) {
  const { currentClinic } = useUser();
  const { t } = useTranslation();
  
  if (!show) return children; 

  if (!currentClinic.id) {
    return (
      <ToggleDrawer>
        <CustomDialog
          showTopCloseButton={true}
          buttonType={"contained"}
          buttonMessage={t("ChooseClinic")}
          buttonSize={"medium"}
          maxWidth={"xs"}
        >
          <ClinicPickerDialog />
        </CustomDialog>
      </ToggleDrawer>
    );
  }

  return children;
}
